/**
 * Services data configuration
 * Contains all service offerings and their details
 */
export const servicesData = [
  {
    id: "mini-projects",
    title: "Mini Projects",
    points: [
      "Python mini projects",
      "AI/ML models",
      "IoT simple prototypes",
      "AR/VR Unity demos",
      "Web mini projects",
      "Mobile app mini projects",
      "Database projects",
    ],
  },
  {
    id: "final-year",
    title: "Final Year Projects",
    points: ["B.E / B.Tech / Arts / Diploma", "CSE / IT / ECE / EEE", "Mechanical / Civil", "B.Sc / BCA"],
  },
  {
    id: "document-services",
    title: "Document Services",
    points: ["Portfolio creation", "Resume building", "Mini project report", "Final year project report", "Research paper writing"],
  },
  {
    id: "design-services",
    title: "Design Services",
    points: ["Logo designing", "Poster / banner designing", "College event poster kits", "Business card"],
  },
  {
    id: "web-app-services",
    title: "Website & App Services",
    points: ["Personal portfolio website", "Business website", "E-commerce mini website", "Blog website", "Simple Android app"],
  },
  {
    id: "tech-support",
    title: "Tech Support Services",
    points: ["Hosting setup", "Domain setup", "GitHub project upload", "Cloud deployment"],
  },
  {
    id: "student-starter",
    title: "Student Starter Package",
    points: ["Portfolio", "Resume", "Mini project", "Mini project report"],
  },
  {
    id: "final-year-package",
    title: "Final Year Package",
    points: ["Final year project", "Full documentation", "PPT + Viva questions", "Deployment"],
  },
  {
    id: "design-package",
    title: "Design Package",
    points: ["Logo", "Poster", "ID card design", "Brochure"],
  },
  {
    id: "developer-package",
    title: "Developer Package",
    points: ["Website", "App", "Deployment", "Domain + hosting setup"],
  },
];

